<template>
  <div>
    <div class="relative">
      <div class="w-full aspect-w-10 aspect-h-7 rounded-lg overflow-hidden">
        <img
          v-if="page.cover"
          :src="page.cover"
          :alt="page.title || 'Page screenshot'"
          class="group-hover:opacity-75 object-cover pointer-events-none"
        />
        <div
          v-else
          class="w-full h-full flex items-center cursor-default justify-center bg-gray-600 group-hover:opacity-75"
        >
          <svg
            class="w-8 h-8 text-gray-300"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0
              1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0
              3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
      </div>
    </div>
    <div class="mt-2 text-center space-x-2">
      <BaseButton v-if="!added" type="button" small primary @click="addPage">
        <Loader small inverse v-if="pending" />
        <span v-else>Add Page</span>
      </BaseButton>
      <BaseButton tag="a" target="_blank" :href="page.url" small success> View </BaseButton>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['createLink'],
  props: {
    page: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      pending: false,
      added: false,
    };
  },
  methods: {
    async addPage() {
      if (this.pending) {
        return;
      }

      try {
        this.pending = true;

        const formData = {
          description: null,
          title: this.page?.title || null,
          url: this.page.url,
        };

        await this.createLink(formData);

        this.added = true;
      } catch (error) {
        //
      } finally {
        this.pending = false;
      }
    },
  },
};
</script>
